import {
    countries
  } from '../helpers/countries';
  import {
    applicantFields,
    premiumField,
    studentNumberFields
  } from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'blanket';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.beneficiaryGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    dependent_fields: [
      ...applicantFields('*', [{
          value: 'dependent',
          text: 'Dependent Child'
        },
        {
          value: 'parent',
          text: 'Parent/Guardian'
        },
        {
          value: 'spouse',
          text: 'Spouse'
        }
      ]),
      ...studentNumberFields('*'),
    ],
    coverage_fields: [
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Home Country',
        type: 'dropdown',
        options: countries()
      },
      {
        key_path: ['application', 'additional_data', 'destination'],
        as: 'Destination',
        type: 'dropdown',
        options: [
          ...countries(true),
          {
            text: 'Worldwide',
            value: 'WW'
          }
        ]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/clients/blanket.js